import hobbiton from '../assets/images/hobbiton.jpg';
import raoros from '../assets/images/raoros.jpg'
import mordor from '../assets/images/mordor.jpg'
import rivendell from '../assets/images/rivendell.jpg'
import lothlorien from '../assets/images/lothlorien.jpg'
import hobbitltd from '../assets/images/hobbitltd.gif'
import hobbitalw from '../assets/images/hobbitalw.gif'
import hobbitvk from '../assets/images/hobbitvk.gif'
import hobbitmtb from '../assets/images/hobbitmtb.gif'
import hobbitptp from '../assets/images/hobbitptp.gif'
import hobbitatd from '../assets/images/hobbitatd.gif'
import hobbitatr from '../assets/images/hobbitatr.gif'
import hobbitkta from '../assets/images/hobbitkta.gif'
import hobbithrt from '../assets/images/hobbithrt.gif'
import hobbittwr from '../assets/images/hobbittwr.gif'
import hobititaps from '../assets/images/hobititaps.gif'
import hobbitrtd from '../assets/images/hobbitrtd.gif'
import hobbitbowl from '../assets/images/hobbitbowl.gif'

export const URL = 'https://api.lorawanta.party'

export const ALL_LOCATIONS = [
    {
      "name": "Hobbiton",
      "miles": 0,
      "sprite": hobbiton,
    },
    {
      "name": "Rivendell",
      "miles": 458,
      "sprite": rivendell,
    },
    {
      "name": "Lothlorien",
      "miles": 929,
      "sprite": lothlorien,
    },
    {
      "name": "Raoros",
      "miles": 1309,
      "sprite": raoros,
    },
    {
      "name": "Mordor",
      "miles": 1779,
      "sprite": mordor,
    },
  ]

export const IMAGE_MAP = {
  hobbitltd,
  hobbitalw,
  hobbitvk,
  hobbitmtb,
  hobbitptp,
  hobbitatd,
  hobbitatr,
  hobbitkta,
  hobbithrt,
  hobbittwr,
  hobititaps,
  hobbitrtd,
  hobbitbowl
}